import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';

import type { useResultSupplierAdvancedSearchCQLQuery_search_ConfluenceSearchConnection_nodes_ConfluenceSearchResponse_content_Content_ancestors_Content as AdvancedSearchCQLQuery_search_nodes_content_ancestors } from '../__types__/useResultSupplierAdvancedSearchCQLQuery.ts';
import type { useResultSupplierAdvancedAGGSearchQuery_search_SearchQueryAPI_search_SearchItemConnection_edges_SearchResultItemEdge_node_SearchConfluencePageBlogAttachment_confluenceEntity_ConfluencePage_ancestors_ConfluencePage as AdvancedAGGSearchQueryNodeConfluenceEntityAncestor } from '../__types__/useResultSupplierAdvancedAGGSearchQuery.ts';

export type breadcrumbAncestor = {
	id: string;
	title: string;
	href: string;
};

export type ancestorBaseSpace = {
	id: string;
	title: string;
	href: string;
};

export const ancestorsTransformer = (
	ancestors:
		| (AdvancedAGGSearchQueryNodeConfluenceEntityAncestor | null)[]
		| (AdvancedSearchCQLQuery_search_nodes_content_ancestors | null)[],
	baseSpace: ancestorBaseSpace | null,
): breadcrumbAncestor[] => {
	const transformedAncestors = ancestors.map((ancestor) => ({
		id: ancestor?.id || '',
		title: ancestor?.title || '',
		href: ancestor?.links?.webUi ? `${CONTEXT_PATH}${ancestor.links.webUi}` : '',
	}));

	// The first breadcrumb ancestor does not contain the correct space name so need to replace by the base space the result comes from
	// Also, non-page results don't have ancestors so we need to make sure it includes the space as its only ancestor
	return baseSpace
		? [{ ...baseSpace, href: `${CONTEXT_PATH}${baseSpace.href}` }, ...transformedAncestors.slice(1)]
		: transformedAncestors;
};
